// Import necessary modules and functions
import { createApi } from "@reduxjs/toolkit/query/react";
import { customFetchBase } from '../../utils/API/fetchBaseQuery';
import { transformErrorResponse, transformSuccessResponse } from "../../utils/API/responseMiddleware";
import { transformRequest } from "../../utils/API/requestMiddleware";

// Create API using createApi function
const developmentListAPI = createApi({
    baseQuery: customFetchBase,
    reducerPath: 'developmentListAPI',
    endpoints: (builder) => ({
        // Endpoint to get development list
        getDevelopmentTodoList: builder.mutation({
            query: (data) => ({
                url: `/DevelopmentList/GetDevelopmentTodoList`,
                method: 'POST',
                body: transformRequest(data),
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),

        getAllTodoStatuses: builder.query({
            query: () => ({
                url: `/DevelopmentList/GetAllTodoStatuses`,
                method: 'GET',
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),

        getAllTodoPriorities: builder.query({
            query: () => ({
                url: `/DevelopmentList/GetAllTodoPriorities`,
                method: 'GET',
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),

        addDevelopmentTodoItem: builder.mutation({
            query: (data) => ({
                url: `/DevelopmentList/AddDevelopmentTodoItem`,
                method: 'POST',
                body: transformRequest(data),
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        
        getAllTodoDetails: builder.query({
            query: (plToDoID) => ({
                url: `/DevelopmentList/GetAllTodoDetails?plToDoID=${plToDoID}`,
                method: 'GET',
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),

        addTodoDetail: builder.mutation({
            query: (data) => ({
                url: `/DevelopmentList/AddTodoDetails`,
                method: 'POST',
                body: transformRequest(data),
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
    }),
});

export const {
    useGetDevelopmentTodoListMutation,
    useLazyGetAllTodoStatusesQuery,
    useLazyGetAllTodoPrioritiesQuery,
    useAddDevelopmentTodoItemMutation,
    useLazyGetAllTodoDetailsQuery,
    useAddTodoDetailMutation
} = developmentListAPI;

export default developmentListAPI;
